import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiLinkedin, FiTwitter, FiMapPin, FiPhone, FiLock, FiShield } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-navy-dark text-metallic-dark pt-16 pb-8 border-t border-white/5">
      <div className="max-w-[1200px] mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
        {/* Brand */}
        <div className="col-span-1 md:col-span-1">
          <div className="flex items-center gap-2 mb-6">
            <img 
              src="/Logo-NIL.png" 
              alt="Nusantara Logistik" 
              className="h-10 md:h-12 w-auto object-contain"
            />
          </div>
          <p className="text-sm mb-6 leading-relaxed">
            Membangun masa depan rantai pasok global dengan teknologi, efisiensi tinggi, dan komitmen pada layanan prima.
          </p>
          <div className="flex gap-4">
            <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-orange hover:text-white transition-colors">
              <SafeIcon icon={FiLinkedin} />
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-orange hover:text-white transition-colors">
              <SafeIcon icon={FiTwitter} />
            </a>
          </div>
        </div>

        {/* Links - Disesuaikan dengan layanan baru */}
        <div>
          <h4 className="text-white font-semibold mb-6">Layanan Cepat</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/services" className="hover:text-orange transition-colors">Pengiriman Udara</Link></li>
            <li><Link to="/services" className="hover:text-orange transition-colors">Pengiriman Laut</Link></li>
            <li><Link to="/services" className="hover:text-orange transition-colors">Pengiriman Darat</Link></li>
            <li><Link to="/services" className="hover:text-orange transition-colors">Jasa Kepabeanan</Link></li>
          </ul>
        </div>

        {/* Perusahaan */}
        <div>
          <h4 className="text-white font-semibold mb-6">Perusahaan</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/about" className="hover:text-orange transition-colors">Tentang Kami</Link></li>
            <li><Link to="/network" className="hover:text-orange transition-colors">Jaringan Global</Link></li>
            <li><a href="#" className="hover:text-orange transition-colors">Karir</a></li>
            <li><a href="#" className="hover:text-orange transition-colors">Berita & Insights</a></li>
          </ul>
        </div>

        {/* Contact & Security */}
        <div>
          <h4 className="text-white font-semibold mb-6">Kontak & Keamanan</h4>
          <ul className="space-y-4 text-sm mb-6">
            <li className="flex items-start gap-3">
              <SafeIcon icon={FiMapPin} className="text-orange mt-1 shrink-0" />
              <span>Gedung Nusantara Tower Lt. 45<br/>Sudirman Central Business District, Jakarta</span>
            </li>
            <li className="flex items-center gap-3">
              <SafeIcon icon={FiPhone} className="text-orange shrink-0" />
              <span>+62 821 1317 248 (24/7)</span>
            </li>
          </ul>

          {/* Security Badges */}
          <div className="flex gap-3">
            <div className="bg-white/5 p-2 rounded border border-white/10 flex items-center gap-2" title="256-bit SSL Encryption">
              <SafeIcon icon={FiLock} className="text-green-400" />
              <span className="text-xs font-mono">SSL Secured</span>
            </div>
            <div className="bg-white/5 p-2 rounded border border-white/10 flex items-center gap-2" title="ISO 27001 Certified">
              <SafeIcon icon={FiShield} className="text-orange" />
              <span className="text-xs font-mono">ISO 27001</span>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-[1200px] mx-auto px-6 border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center text-xs">
        <p>&copy; Nusantara International Logistik. All rights reserved.</p>
        <div className="flex gap-4 mt-4 md:mt-0">
          <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
          <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;